import { render, staticRenderFns } from "./supplier-order-detail.vue?vue&type=template&id=42b8fcc8&scoped=true"
import script from "./supplier-order-detail.vue?vue&type=script&lang=js"
export * from "./supplier-order-detail.vue?vue&type=script&lang=js"
import style0 from "./supplier-order-detail.vue?vue&type=style&index=0&id=42b8fcc8&prod&lang=scss&scoped=true"
import style1 from "./supplier-order-detail.vue?vue&type=style&index=1&id=42b8fcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b8fcc8",
  null
  
)

export default component.exports